import React, { useState, useEffect } from "react";
import { db } from "../firebase";
import { doc, getDoc } from "firebase/firestore";
import { FaGooglePlay, FaTimes } from "react-icons/fa";
import packageInfo from "../../package.json";

const CURRENT_VERSION = packageInfo.version;

const UpdatePopup = () => {
  const [updateData, setUpdateData] = useState(null);

  useEffect(() => {
    const checkUpdate = async () => {
      try {
        const docRef = doc(db, "app_settings", "general_config");
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          const data = docSnap.data();
          if (data.latest_version && data.latest_version !== CURRENT_VERSION) {
            setUpdateData(data);
          }
        }
      } catch (error) {
        console.error(error);
      }
    };

    checkUpdate();
  }, []);

  if (!updateData) return null;

  return (
    <div className="fixed inset-0 z-[9999] bg-black/70 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-2xl p-6 max-w-sm w-full text-center relative animate-fade-in">
        
        {!updateData.force_update && (
          <button onClick={() => setUpdateData(null)} className="absolute top-3 right-4 text-gray-400 hover:text-gray-600 transition">
            <FaTimes size={16} />
          </button>
        )}
        
        <div className="text-5xl mb-4">🚀</div>
        <h3 className="text-xl font-black text-gray-800 mb-2">नया अपडेट उपलब्ध है!</h3>
        <p className="text-sm text-gray-500 font-medium mb-6">
          बेहतर अनुभव और नए फीचर्स के लिए कृपया ऐप को अपडेट करें।
        </p>
        
        <a
          href={updateData.update_url || "https://play.google.com/store/apps/details?id=com.sarvagyastudentsathi.app"}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center justify-center gap-2 w-full py-3 rounded-xl font-bold bg-blue-600 text-white hover:bg-blue-700 transition shadow-md"
        >
          <FaGooglePlay size={18} />
          अभी अपडेट करें
        </a>
        
        {!updateData.force_update && (
          <button onClick={() => setUpdateData(null)} className="mt-4 text-sm font-bold text-gray-400 hover:text-gray-600 transition w-full">
            बाद में याद दिलाएं
          </button>
        )}
        
      </div>
    </div>
  );
};

export default UpdatePopup;